import type { ReactNode } from 'react';

interface TileCardProps {
  title: string;
  help: string;
  children: ReactNode;
  footer?: ReactNode;
  loading?: boolean;
  error?: string | null;
  // When true, help text is hidden (used on the overview page where tiles
  // are glance-only and uniform height matters more than inline help).
  hideHelp?: boolean;
}

// Generic card used by every dashboard tile. Enforces the pattern:
// - title,
// - inline help text explaining the data, time window, and what "bad" looks like
// - loading + error states handled consistently
// - optional footer for drill-down links.
export default function TileCard({ title, help, children, footer, loading, error, hideHelp }: TileCardProps) {
  return (
    <section className="tile-card" aria-busy={loading || undefined}>
      <header className="tile-header">
        <h2 className="tile-title">{title}</h2>
      </header>
      {!hideHelp && (
        <p className="tile-help" role="note">
          {help}
        </p>
      )}
      <div className="tile-body">
        {loading && <div className="tile-loading">Loading…</div>}
        {!loading && error && <div className="tile-error">Error: {error}</div>}
        {!loading && !error && children}
      </div>
      {footer && <footer className="tile-footer">{footer}</footer>}
    </section>
  );
}
